import { Select, SelectItem, SelectProps } from '@mantine/core';

type SpecialFieldSourceSelectProps = Omit<SelectProps, 'data'>;

const sources: SelectItem[] = [{ value: 'foreignId', label: 'Cudzí kľúč' }];

/**
 * Select for supported Chastia special field sources.
 */
export default function SpecialFieldSourceSelect(props: SpecialFieldSourceSelectProps) {
  return <Select data={sources} placeholder="Vybrať špeciálne pole" {...props} />;
}
